import { HttpService } from '../services/httpService';
import { StorageService } from '../services/StorageService';
import { CryptoService } from '../services/CryptoService';
import { Router, ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';


@Component({
  selector: 'app-register-component',
  templateUrl: './register.component.html'
})
export class RegisterComponent {
  public currentCount = 0;

  public incrementCounter() {
    this.currentCount++;
  }

  os;
  storeKey: string;
  storeId: string;

  stage1: boolean = true;
  stage2: boolean = false;
  stage2half: boolean = false;
  stage3: boolean = false;
  stage4: boolean = false;
  complete: boolean = false;
  constructor(private httpService: HttpService, public router: Router,
    private localStorage: StorageService, private cryptoService: CryptoService,) {


    this.os = this.getMobileOperatingSystem();


    this.localStorage.clearAll();

    this.fetchBusinessTypes();
    this.fetchBusinessClassifications();

  }

  loading: boolean = false;

  error: boolean = false;
  message = '';


  businessTypes;
  businessClassifications;

  fetchBusinessTypes() {

    this.httpService.post<any>('Store/fetch-business-types', false).subscribe(
      resp => {

        
        this.businessTypes = JSON.parse(resp.message);
        //console.log(resp)
        console.log(this.businessTypes)
        this.loading = false;

      },
      error => {
        this.loading = false;


        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });



  }




  fetchBusinessClassifications() {

    this.httpService.post<any>('Store/fetch-business-classifications', false).subscribe(
      resp => {


        this.businessClassifications = JSON.parse(resp.message);
        //console.log(resp)
        console.log(this.businessClassifications)
        this.loading = false;


      },
      error => {
        this.loading = false;


        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });



  }










  secondStep() {





    if (this.businessName.length < 3) { this.error = true; this.message = 'Enter valid business name' }
    else if (this.businessStreetAddress.length < 3) { this.error = true; this.message = 'Enter valid business street address' }
    else if (this.businessCity.length < 3) { this.error = true; this.message = 'Enter valid business city' }
    else if (this.businessPostalCode.length != 5) { this.error = true; this.message = 'Enter valid business postal code' }
    else if (this.businessState.length != 2) { this.error = true; this.message = 'Enter valid business state' }
    else {
      window.scroll(0, 0);
      this.error = false;
      this.stage1 = false;
      this.stage2 = true;
    }

  }

  twoHalfStep() {



    if (this.checkEmail(this.businessEmail) == false) { this.error = true; this.message = 'Enter valid business email' }
    else if (this.businessPhoneNumber.length != 10) { this.error = true; this.message = 'Enter valid 10 digit business phone' }
    else if (this.businessWebsiteLink.length == 0) { this.error = true; this.message = 'Enter valid business website' }
    else if (this.businessType == 0) { this.error = true; this.message = 'Enter valid business type' }
    else if (this.businessClassification == 0) { this.error = true; this.message = 'Enter valid business classificaion' }
    else if (this.checkEin(this.businessEin) == false) { this.error = true; this.message = 'Enter valid business EIN: XX-XXXXXXX' }
    else {
      window.scroll(0, 0);
      this.error = false;

      this.stage2 = false;
      this.stage2half = true;

    }


  }
  thirdStep() {
    

    if (this.businessUsername.length < 5) { this.error = true; this.message = 'Try a different business username of more than 6 characters' }
    //else if (this.checkUsername(this.businessUsername) == false) { this.error = true; this.message = 'Username taken! Try another one' }
    else if (this.businessBio.length == 0) { this.error = true; this.message = 'Enter valid business bio' }
    else {


      this.checkUsername();

      

    }

  


  }



  forthStep() {



    if (this.ownerFirstName.length < 5) { this.error = true; this.message = 'Enter valid first name' }
    else if (this.ownerLastName.length == 0) { this.error = true; this.message = 'Enter valid last name' }
    else if (this.ownerTitle.length == 0) { this.error = true; this.message = 'Enter valid title' }
    else if (this.checkEmail(this.ownerEmail) == false) { this.error = true; this.message = 'Enter valid email' }
    else if (this.ownerPhone.length != 10) { this.error = true; this.message = 'Enter valid phone number' }
    else if (this.checkDob(this.ownerDob) == false) { this.error = true; this.message = 'Enter valid date of birth ex - 1990-01-10' }
    else if (this.ownerSsn.length != 4) { this.error = true; this.message = 'Enter valid last 4 digits of SSN' }
    else if (this.ownerStreetAddress.length < 2) { this.error = true; this.message = 'Enter valid street address' }
    else if (this.ownerCity.length < 2) { this.error = true; this.message = 'Enter valid city' }
    else if (this.ownerState.length != 2) { this.error = true; this.message = 'Enter valid state' }
    else if (this.ownerPostalCode.length != 5) { this.error = true; this.message = 'Enter valid postal code' }
    else {
      window.scroll(0, 0);

      this.error = false;

      this.stage3 = false;
      this.stage4 = true;

    }


  }



  completeStep() {
    if (this.bankRoutingNumber.length == 0) { this.error = true; this.message = 'Enter valid routing number' }
    else if (this.bankAccountNumber.length == 0) { this.error = true; this.message = 'Enter valid bank account number' }

    else {
      window.scroll(0, 0);

      this.error = false;


      this.stage4 = false;
      this.register();
    }



  }


  businessName = '';
  businessStreetAddress = '';
  businessCity = '';
  businessState = '';
  businessPostalCode = '';

  businessEmail = '';
  businessPhoneNumber = '';
  businessWebsiteLink = '';
  businessType = 0;
  businessEin = '';
  businessClassification = 0;

  businessUsername = '';
  businessBio = '';

  ownerFirstName = '';
  ownerLastName = '';
  ownerTitle = '';
  ownerEmail = '';
  ownerPhone = '';
  ownerDob = '';
  ownerSsn = '';
  ownerStreetAddress = '';
  ownerCity = '';
  ownerState = '';
  ownerPostalCode = '';

  bankRoutingNumber = '';
  bankAccountNumber = '';








  checkEmail(chunk) {

    var emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!emailReg.test(chunk)) {
      //alert('Enter valid email');
      return false;
    }

    return true;
  }



  checkEin(chunk) {

    var einReg = /^(0[1-9]|[1-9]\d)-\d{7}$/;
    if (!einReg.test(chunk)) {
      //alert('Enter valid email');
      return false;
    }

    return true;
  }

 



  checkDob(chunk) {

    var einDob = /^([0-9]{4})\-([0-9]{2})\-([0-9]{2})$/;
    if (!einDob.test(chunk)) {
      //alert('Enter valid email');
      return false;
    }

    return true;
  }



  register() {

    this.loading = true;

    const request = {
      BusinessName: this.businessName,
      BusinessStreetAddress: this.businessStreetAddress,
      BusinessCity: this.businessCity,
      BusinessState: this.businessState,
      BusinessPostalCode: this.businessPostalCode,
      BusinessEmail: this.businessEmail,
      BusinessPhoneNumber: this.businessPhoneNumber,
      BusinessWebsiteLink: this.businessWebsiteLink,
      BusinessType: this.businessType,
      BusinessEin: this.businessEin,
      BusinessClassification: this.businessClassification,
      BusinessUsername: this.businessUsername,
      BusinessBio: this.businessBio,
      OwnerFirstName: this.ownerFirstName,
      OwnerLastName: this.ownerLastName,
      OwnerTitle: this.ownerTitle,
      OwnerEmail: this.ownerEmail,
      OwnerPhone: this.ownerPhone,
      OwnerDob: this.ownerDob,
      OwnerSsn: this.ownerSsn,
      OwnerStreetAddress: this.ownerStreetAddress,
      OwnerCity: this.ownerCity,
      OwnerState: this.ownerState,
      OwnerPostalCode: this.ownerPostalCode,
      BankRoutingNumber: this.bankRoutingNumber,
      BankAccountNumber: this.bankAccountNumber

    }

    this.httpService.post<any>('Store/vendor-onboarding', request, false).subscribe(
      resp => {

        if (JSON.parse(resp.message).message == 'success') {
          this.complete = true;

        }




        this.loading = false;


      },
      error => {
        this.loading = false;

        console.log(error);

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });




  }




  userName: boolean = false;


  checkUsername() {

    this.loading = true;

    const request = {

      Username: this.businessUsername,


    }

    this.httpService.post<any>('Store/check-vendor-username', request, false).subscribe(
      resp => {


        if (JSON.parse(resp.message).message == 'yes') {
          this.loading = false;


          window.scroll(0, 0);
          this.error = false;

          this.stage2half = false;
          this.stage3 = true;


        }
        else {
          this.error = true;
          this.message = 'Username taken! Try another one'
          this.loading = false;
        }






      },
      error => {
        this.loading = false;




      });

  }



















  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent;

    if (userAgent.toUpperCase().indexOf('ANDROID') > 0) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710

    if (userAgent.toUpperCase().indexOf('IPAD') > 0 || userAgent.toUpperCase().indexOf('IPHONE') > 0 || userAgent.toUpperCase().indexOf('IPOD') > 0) {
      return "iOS";
    }

    return "unknown";

  }











}
